import { useState, useEffect } from "react";
import { observer, inject } from "mobx-react";
import LoadingContainer from "../layouts/LoadingContainer";
import { isOnlyContsale } from "../utils/spaceModes";
import { Outlet } from "react-router-dom";
import Header from "../layouts/Header";
import SideBar from "../layouts/SideBar";
import { useTranslation } from "react-i18next";
import { ScrollDiv } from "../components/Common";
import { BottomDrawer } from "../components/BottomDrawer";
import { Role } from "../stores/userStore";
import { useMobile } from "../utils/mobile";
import MobileHeader from "../layouts/MobileHeader";
import MobileDrawer from "./MobileDrawer";
import addSquareImg from "../assets/img/add-square.svg";
import NewApply from "../layouts/NewApply";
import { useTheme } from "styled-components";
import { useLocation } from "react-router-dom";

const Tenant = ({ userStore, tenantsStore }) => {
  // Start in loading state so children (Lobby, Header) don't mount and fire
  // their fetches before the mount effect below loads the sale contract —
  // otherwise they fetch once with a stale/null contract and again after.
  const [isLoading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const [title, setTitle] = useState(t("menu:lobby"));
  const [departments, setDepartments] = useState([]);
  const [showDepratmentsMenu, setShowDepratmentsMenu] = useState(false);
  const theme = useTheme();
  const location = useLocation();

  const isMobile = useMobile();

  useEffect(() => {
    const fetchSaleContracts = async () => {
      setLoading(true);
      tenantsStore.setError("");

      let contract = tenantsStore.selectedSiteSpace?.CONTNAME


      if (!!contract) {
        const projData = {
          MAINCUST: tenantsStore.selectedSiteSpace.CUST,
          CUST: tenantsStore.selectedSiteSpace.CUST,
          MAINENV: tenantsStore.selectedSiteSpace.DNAME,
          BUILDINGNUM: tenantsStore.selectedSiteSpace?.BUILDINGNUM,
          CONTNAME: tenantsStore.selectedSiteSpace?.CONTNAME,
          DNAME: tenantsStore.selectedSiteSpace?.DNAME,
        }
        await tenantsStore.getSaleContract(projData);
      }

      if (!!tenantsStore.selectedContract?.CONT) {
        const selectedProjData = {
          MAINCUST: tenantsStore.selectedSiteSpace.CUST,
          CUST: tenantsStore.selectedSiteSpace.CUST,
          MAINENV: tenantsStore.selectedSiteSpace?.DNAME,
          CUSTNAME: tenantsStore.selectedContract.CUSTNAME,
          SITEID: tenantsStore.selectedSiteSpace?.SITEID,
          BUILDINGNUM: tenantsStore.selectedContract?.BUILDINGNUM,
          DNAME: tenantsStore.selectedSiteSpace?.DNAME


        };
        tenantsStore.getProjectImage(selectedProjData);
        const departments = await tenantsStore.getDepartments(
          selectedProjData
        );
        setDepartments(departments || []);
        //   }
      }

      setLoading(false);
    };
    fetchSaleContracts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantsStore.selectedSiteSpace]);

  useEffect(() => {
    const getData = async () => {
      const selectedMessage = tenantsStore.selectedContract
        ?.ZCOM_TENANTMESSAGES_SUBFORM?.length
        ? tenantsStore.selectedContract?.ZCOM_TENANTMESSAGES_SUBFORM[0]
        : undefined;
      const selectedDoc =
        tenantsStore.selectedContract?.EXTFILES_SUBFORM?.filter(
          (ext) => ext.SUFFIX === "pdf"
        )?.length
          ? tenantsStore.selectedContract?.EXTFILES_SUBFORM?.filter(
            (ext) => ext.SUFFIX === "pdf"
          )[0]
          : undefined;
      tenantsStore.setSelectedDoc(selectedDoc);
      tenantsStore.setSelectedMessage(selectedMessage);
    };

    if (
      !!tenantsStore.selectedContract?.CONT &&
      tenantsStore.selectedContract.SITEID
    ) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantsStore.selectedContract]);

  return (
    <div
      style={{
        height: "100vh",
      }}
    >
      <LoadingContainer isLoading={isLoading}>
        {isMobile && (
          <MobileHeader
            name={userStore.userDetails.NAME}
            title={title}
            admin={userStore.userDetails.role === Role.Admin}
          />
        )}
        {!isMobile ? (
          <SideBar
            logo={userStore.userDetails.LOGO}
            setTitle={setTitle}
            departments={[
              ...(tenantsStore.selectedSiteSpace?.CONTSALE === "Y"
                ? (departments || []).filter((d) => d.BEDEKFLAG !== "Y")
                : []),
              ...(tenantsStore.selectedSiteSpace?.BEDEK === "Y"
                ? [{ DEPARTDES: t("menu:bedek"), BEDEKFLAG: "Y" }]
                : []),
            ]}
          >
            <Header
              name={userStore.userDetails.NAME}
              title={title}
              admin={userStore.userDetails.role === Role.Admin}
            />
            <ScrollDiv maxHeight={"calc(100vh - 84px)"}>
              <Outlet />
            </ScrollDiv>
          </SideBar>
        ) : (
          <div>
            <MobileDrawer
              setTitle={setTitle}
              departments={departments?.filter((d) =>
                isOnlyContsale(tenantsStore.selectedSiteSpace) ||
                  tenantsStore.selectedSiteSpace?.CONTSALE === "Y"

                  ? d.BEDEKFLAG !== "Y"
                  : true
              )}
            >
              <Outlet />
              {location.pathname.includes("/lobby") && (
                <NewApply
                  isMobile={true}
                  backgroundColor={theme.color.green}
                  style={{
                    flex: 1,
                    justifyContent: "end",
                    alignSelf: "center",
                    position: "absolute",
                    left: isRtl ? 20 : "unset",
                    right: isRtl ? "unset" : 20,
                    bottom: 30,
                    zIndex: 999,
                  }}
                  setTitle={setTitle}
                  img={addSquareImg}
                  onItemClicked={() => {
                    setShowDepratmentsMenu(!showDepratmentsMenu);
                  }}
                />
              )}
              {showDepratmentsMenu && (
                <BottomDrawer
                  items={departments}
                  setShow={setShowDepratmentsMenu}
                  show={showDepratmentsMenu}
                />
              )}
            </MobileDrawer>
          </div>
        )}
      </LoadingContainer>
    </div>
  );
};

export default inject("userStore", "tenantsStore")(observer(Tenant));
